import classes from "../../../styles/Subscription.module.css";
import SubscriptionContainer from "../components/pageComponents/SubscriptionComps/SubscriptionContainer";
const Subscription = () => {
    return (
        <div><SubscriptionContainer /></div>
    )
}
export default Subscription;